<template>
  <div v-html="content">
  </div>
</template>
<script>
// import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { protocolDetail } from '../../apis/user'
export default {
  // components: {
  //   Editor,
  //   Toolbar
  // },
  data() {
    return {
      editor: null,
      editorConfig: { readOnly: true },
      content: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    getData() {
      protocolDetail({ id: this.$route.query.id }).then(res => {
        this.content = res.data.protocolContent
      })
    }
  },
}

</script>
<style lang="scss" scoped>

</style>